import React from 'react';
import { BundleProductShortDescription } from 'components/WeddingBundles/BundleProduct';
import { Product } from 'types/Product';
import './weddingBundles.css';
import { useDispatch } from 'react-redux';
import { addItemToCartRequest } from 'store/cart/actions';
import { DesktopBreadcrumbs } from 'components/Breadcrumbs';

interface WeddingBundlesProps {
  category?: {
    canonicalUrl: string;
    metaDescription: string;
    metaTitle: string;
    title: string;
    products: Product[];
  };
}

const WEDDING_BUNDLES_CATEGORY = 'wedding bundles';
const COLLECTIONS_PRODUCT_LINE = 'collections';
const PDP_LOCATION = 'pdp';

const breadcrumbPages = [
  {
    name: 'Home',
    urlPath: '/'
  },
  {
    name: 'Wedding',
    urlPath: '/wedding'
  },
  {
    name: 'Wedding Collections',
    urlPath: '/wedding/wedding-collections'
  },
  {
    name: 'Albums',
    urlPath: '/albums'
  }
];

const WeddingBundles = ({ category }: WeddingBundlesProps): JSX.Element => {
  const dispatch = useDispatch();

  if (!category) {
    console.error('Wedding Albums category not found');
  }

  const handleAddToCart = (product: Product) => {
    const cartItem = {
      sku: product.sku.replace(/\+/g, ' '),
      qty: 1,
      pageCount: undefined,
      redirectToEditor: undefined,
      projectId: undefined,
      projectVersion: undefined,
      editorVersion: '1',
      hammerCategory: undefined
    };

    const analyticsData = {
      product_id: product.productId,
      sku: product.sku,
      name: product.name,
      price: parseFloat(product.price?.toString() || '0'),
      is_customizable_product: false,
      category: WEDDING_BUNDLES_CATEGORY,
      product_line: COLLECTIONS_PRODUCT_LINE,
      location: PDP_LOCATION
    };

    dispatch(addItemToCartRequest(cartItem, analyticsData));
  };

  return (
    <div className="container">
      <DesktopBreadcrumbs pages={breadcrumbPages}></DesktopBreadcrumbs>
      <div className="products-grid" id="top-albums">
        {category.products.map(product => (
          <BundleProductShortDescription
            key={product.productId}
            product={product}
            onAddToCart={() => handleAddToCart(product)}
          />
        ))}
      </div>
    </div>
  );
};

export default WeddingBundles;
